export default __webpack_public_path__ + "static/media/kitchen3-afterB-480w.0443512a.webp";